import { UsersPage } from 'features/users';

export const AdminUsersPage: React.FC = () => <UsersPage />;
